import axios from "axios";


export const getDefaultInfo = async () => {
  const res = await axios.get("/api/default/info");
  return res.data;
};
export const getFeatureServicesInfo = async () => {
  const res = await axios.get("/api/default/services");
  return res.data;
};

export const getDoctorsInfo = async () => {
  const res = await axios.get("/api/doctors");
  return res.data;
};

export const getDepartmentsInfo = async () => {
  const res = await axios.get("/api/departments");
  return res.data;
};


export const getTeamInfo = async () => {
  const res = await axios.get("/api/teams");
  return res.data;
}


export const getNewsInfo = async () => {
  const res = await axios.get("/api/news");
  return res.data;
}